import React from "react";

import toast from "../ui/toast";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import "react-google-places-autocomplete/dist/assets/index.css";

import "./SearchBar.css";

const SearchBar = ({
  isLoading,
  setBusinessAddress,
  businessAddress,
  handleOpenModalBusinessInfo,
  submitBusiness,
  isSa,
}) => {
  const onSubmit = async () => {
    if (isLoading) return;
    if (businessAddress === undefined || businessAddress === "") {
      toast.error("Veuillez sélectionner un établissement");
    } else {
      try {
        if (!isSa) {
          await handleOpenModalBusinessInfo();
        } else {
          await submitBusiness(businessAddress);
        }
      } catch (err) {
        console.log("error");
        toast.error(err?.message || String(err));
      }
    }
  };

  return (
    <div className="search-form">
      <div className="search-form__card">
        <div className="search-form__row">
          <div className="search-form__input-wrap">
            <GooglePlacesAutocomplete
              placeholder="Nom de votre établissement"
              onSelect={({ description }) => setBusinessAddress(description)}
              className="input-businessName"
              renderSuggestions={(active, suggestions, onSelectSuggestion) => (
                <div className="suggestions-container">
                  {suggestions.map((suggestion, index) => (
                    <div
                      className="suggestion"
                      key={index}
                      onClick={(event) => onSelectSuggestion(suggestion, event)}
                    >
                      <span className="suggestion__icon">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                      </span>
                      {suggestion.description}
                    </div>
                  ))}
                </div>
              )}
            />
          </div>
          <button
            className={`search-form__btn${isLoading ? " search-form__btn--loading" : ""}`}
            type="submit"
            onClick={onSubmit}
            disabled={isLoading}
          >
            {isLoading ? "Analyse en cours..." : "Analyser"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
